module.exports = __webpack_public_path__ + "static/media/intro-wiz.67ca36c0.svg";